import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const CurrentContentScorePage = lazy(
  () => import('~/features/content-enrichment/pages/current-content-score-page'),
);

export const Route = createFileRoute(
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CurrentContentScorePage />
    </Suspense>
  ),
});
